export const resetHomeConfiguration = () => {
  localStorage.removeItem('/home.customHomepage/home');
  location.reload();
};

export const isDev = () =>
  window.location.href.includes('test.ip-capture') || window.location.href.includes('localhost');
